module.exports = ".column {\n  padding: 3%;\n  margin: 5%;\n  -webkit-box-shadow: 0 10px 10px -6px #dbdbdb;\n          box-shadow: 0 10px 10px -6px #dbdbdb; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hunt/components/booking-status/booking-status.component.scss
// module id = ./src/app/hunt/components/booking-status/booking-status.component.scss
// module chunks = main